<h1 mat-dialog-title>{{ castDevice.friendlyName }}</h1>
<mat-dialog-content>
  Are you certain you want to stop casting?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="closeDialog()">No</button>
  <button mat-button (click)="stop()">Yes</button>
</mat-dialog-actions>
